<button [mat-dialog-close]="false" class="close-round">
  <span class="close-round__btn"></span>
</button>

<add-demo-funds-widget
  [account]="data.account"
  [isChild]="true"
  (success)="onSuccess($event)"
  (error)="onError($event)"
  class="add-demo-popup"
/>
